export const EXTERN_API = "https://elektricienoffertes.com/api/public/extern";
export type ApiResult = {
  ok?: boolean; melding?: string; velden?: Record<string, string> | string[];
  gevonden?: boolean; straat?: string; plaats?: string; postcode?: string;
  verzonden?: boolean; overslaan?: boolean; kanaal?: "sms" | "email";
  geldig?: boolean; samenvatting?: string; categorie?: string; aandachtspunten?: string[]; id?: string;
};
export class OfferteApiError extends Error {
  velden?: Record<string, string>;
  constructor(message: string, velden?: Record<string, string> | string[], public status?: number) { super(message); this.velden = Array.isArray(velden) ? Object.fromEntries(velden.map(v => [v, "Controleer dit veld."])) : velden; }
}
export function retryMinutes(header: string | null, now = Date.now()) {
  const seconds = header && /^\d+$/.test(header) ? Number(header) : header ? (Date.parse(header) - now) / 1000 : 60;
  return Math.max(1, Math.ceil((Number.isFinite(seconds) ? seconds : 60) / 60));
}
// Only called from browser effects/events; no proxy and no automatic retries.
export async function externPost(path: string, data: unknown, signal?: AbortSignal): Promise<ApiResult> {
  let response: Response;
  try {
    response = await fetch(`${EXTERN_API}${path}`, {
      method: "POST", credentials: "omit", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data), signal,
    });
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") throw error;
    throw new OfferteApiError("De verbinding is niet beschikbaar. Probeer het later opnieuw.");
  }
  const result: ApiResult = await response.json().catch(() => ({}));
  if (response.status === 429) throw new OfferteApiError(`Te veel pogingen, probeer het over ${retryMinutes(response.headers.get("Retry-After"))} minuten opnieuw`, result.velden, 429);
  if (!response.ok || result.ok === false) throw new OfferteApiError(result.melding || (response.status === 404 ? "De aanvraagservice is nog niet beschikbaar. Probeer het later opnieuw." : "Er ging iets mis. Probeer het later opnieuw."), result.velden, response.status);
  return result;
}
export type WizardGegevens = {
  postcode: string; huisnummer: string; plaats: string; straat: string;
  type_opdracht: string; soort_aanvraag: string; uitvoerdatum: string; intentie: string;
  omschrijving: string; voornaam: string; achternaam: string; telefoon: string; email: string;
};
export type OfferteFoto = { name: string; url: string };
export const MAX_OFFERTE_FOTOS = 4;
export function kanFotosToevoegen(aantal: number, nieuw: number) { return aantal + nieuw <= MAX_OFFERTE_FOTOS; }
export function aanvraagPayload(gegevens: WizardGegevens, product: string | null, fotos: OfferteFoto[], analyse: ApiResult | null) {
  return { ...gegevens, bron: "elvion-group", product,
    huisnummer: gegevens.huisnummer || null, type_opdracht: gegevens.type_opdracht || null,
    soort_aanvraag: gegevens.soort_aanvraag || null, uitvoerdatum: gegevens.uitvoerdatum || null,
    intentie: gegevens.intentie || null, omschrijving: gegevens.omschrijving.slice(0, 5000) || null,
    fotos, ai_samenvatting: analyse?.samenvatting || null, ai_categorie: analyse?.categorie || null,
    ai_aandachtspunten: analyse?.aandachtspunten || [] };
}